var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",class:{ active: _vm.openSidebar },on:{"click":function($event){$event.preventDefault();return _vm.toggleSidebar.apply(null, arguments)}}},[_c('div',{staticClass:"sidebar-menus"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }